export default __webpack_public_path__ + "Entering Corrective Action Data into the GSW - District Guide.pdf";